import { render, staticRenderFns } from "./MyDriversProfile.vue?vue&type=template&id=46dc594c&lang=pug&"
import script from "./MyDriversProfile.vue?vue&type=script&lang=ts&"
export * from "./MyDriversProfile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports